<template>
  <div class="view-automations-zapier">
    <h4 class="text-semibold mb-5">Zapier</h4>
    <snow-data-table-header
      class="mb-6"
      @add="modal = true"
      @searching="searching"
      :datePicker="false"
      :filters="false"
    />
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <snow-data-table :data="integrationList" :columns="zapierColumns">
        <template #eventos="{ value }">
          <snow-table-events :events="value" />
        </template>
        <template #url="{ item }">
          <div class="d-flex">
            <snow-button variant="borderless" size="sm" @click="copyUrl(item)">
              <i class="ph ph-link" />
            </snow-button>
            <snow-button variant="borderless" size="sm" @click="openUrl(item)">
              <i class="ph ph-arrow-square-out" />
            </snow-button>
          </div>
        </template>
        <template #no-content-actions>
          <snow-button
            icon="ph ph-plus"
            text="Adicionar integração"
            @click="modal = true"
          />
        </template>
      </snow-data-table>
      <!-- Mobile area -->
      <div class="d-flex justify-content-end mt-4">
        <snow-paginator
          v-model="page"
          :pagination="pagination"
          @change-page="dispatch"
        />
      </div>
    </div>
    <zapier-modal
      v-model="modal"
      :integrationToEdit="integrationToEdit"
      @clear-edit="integrationToEdit = null"
      @update-list="dispatch"
    />
  </div>
</template>
<script>
import ZapierModal from "@/components/tools/modals/Zapier.vue";
import IntegrationsMixin from "@/mixins/integration.js";

export default {
  mixins: [IntegrationsMixin],
  components: {
    ZapierModal
  },
  data() {
    return {
      integration: "zapier"
    };
  },
  mounted() {
    this.$store.commit("integration/setIntegration", this.integration);
    this.dispatch();
  },
  computed: {
    webhookTest() {
      return {
        text: "Enviar teste",
        class: "",
        icon: "icon-arrow-right",
        confirmation: {
          enable: false,
          text: ""
        },
        event: "test-webhook"
      };
    },
    zapierColumns() {
      return [
        {
          name: "Produto",
          field: "events",
          transform: (value, item) => this.productName(item)
        },
        {
          name: "Descrição",
          field: "description",
          transform: v => this.formatLongText(v)
        },
        {
          name: "Eventos",
          field: "events",
          transform: v => v.map(e => e.event)
        },
        {
          name: "URL",
          field: "url"
        },
        {
          name: "Status",
          field: "status",
          transform: v => (v ? "Ativo" : "Inativo"),
          color: v => (v ? "green" : "negative"),
          type: "tag"
        },
        {
          type: "menu",
          options: this.getActions
        }
      ];
    }
  },
  methods: {
    formatLongText(txt) {
      if (txt) {
        return txt.length > 20 ? `${txt.slice(0, 20)}...` : `${txt}`;
      }
      return "-";
    },
    dispatch() {
      this.$store.dispatch("integration/getTypeEvents");
      let params = {};

      if (this.search) {
        params = { search: this.search };
      }
      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", params)
        .catch(error => {
          this.$message.error("Não foi possível carregar as integrações");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStatus(item) {
      let data = item;
      data.status = !item.status;
      data.product_id = item.events[0].product_id;
      this.$store
        .dispatch("integration/putIntegration", data)
        .then(() => {
          this.$message.success(
            `Integração ${data.status ? "ativada" : "desativada"}`
          );
        })
        .catch(() => {
          this.$message.error(
            "Não foi possível alterar o status da integração"
          );
        });
    },
    getActions(item) {
      return [
        {
          label: item.status ? "Desativar" : "Ativar",
          click: this.changeStatus
        },
        {
          label: "Editar",
          click: this.edit
        },
        {
          label: "Excluir",
          class: "text-danger",
          variant: "danger",
          dialog: {
            text: "Deseja mesmo excluir esta integração?",
            icon: "ph ph-trash",
            buttonText: "Sim, excluir",
            secondaryButtonText: "Não, cancelar",
            action: this.submitDelete
          }
        }
      ];
    }
  }
};
</script>
